import { render, staticRenderFns } from "./AreaLayout.vue?vue&type=template&id=20e71823&"
import script from "./AreaLayout.vue?vue&type=script&lang=js&"
export * from "./AreaLayout.vue?vue&type=script&lang=js&"
import style0 from "./AreaLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports